import styled from 'styled-components'
import { gray } from 'sutra/tokens/colors'

export const Container = styled.div`
  height: 100%;
  background: #ffffff;
  border-left: 1px solid #e5e7eb;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Group = styled.div`
  display: flex;
  flex-direction: column;
`

export const GroupHeader = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
`

export const ValueRow = styled.div<{ $interactive: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 4px;
  border-radius: 3px;
  border-bottom: 4px solid #ffffff;
  cursor: ${(p) => (p.$interactive ? 'pointer' : 'default')};
  &:last-child {
    border-bottom: 0;
  }
  &:hover {
    background: ${(p) => (p.$interactive ? '#f3f4f6' : 'transparent')};
  }
`

export const Swatch = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
`

export const ValueText = styled.span`
  font-size: 13px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Footer = styled.div`
  margin-top: auto;
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
`

export const ParentRowCountLabel = styled.span`
  font-family: 'Poppins', system-ui, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: ${gray[500]};
  white-space: nowrap;
`

export const PaginationWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 4px 8px;
`

export const PaginationSummary = styled.span`
  font-size: 13px;
  color: #5072a4;
  white-space: nowrap;
`

export const PaginationButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
`

export const NavButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  color: ${({ $disabled }) => ($disabled ? '#c8c8c8' : '#374151')};
  transition: color 0.2s ease;
  &:hover {
    color: ${({ $disabled }) => ($disabled ? '#c8c8c8' : '#111827')};
  }
`

export const SvgIcon = styled.svg`
  width: 18px;
  height: 18px;
  fill: currentColor;
  display: block;
`
